import { memo } from "react";
import { Grid, Typography } from "@mui/material";

function Quotes({ quote }) {
	if (!quote) {
		return null;
	}
	
	return (
		<Grid container item justifyContent="center">
			<Grid item xs={9} sm={7}>
				<Typography
					variant="body1"
					sx={{ textAlign: "center", mb: 1, whiteSpace: 'pre-wrap' }}
				>
					<strong>
						{ quote.content }
					</strong>
				</Typography>
			</Grid>
			<Grid item xs={9} sm={7}>
				<Typography
					variant="body1"
					sx={{ textAlign: "center" }}
				>
					<strong>
						{ quote.author }
					</strong>
				</Typography>
				<Typography
					variant="body1"
					sx={{ textAlign: "center" }}
				>
					{ quote.company }
				</Typography>
			</Grid>
		</Grid>
	);
}

export default memo(Quotes);
